import React from 'react';
import { IconProps } from './IconTypes';

// Deliberately generic "hex chip" mark — a hexagonal ring around a center
// node. Used as the brand mark for frontier labs that have no real logo (the
// spreadsheet's anonymous "US Co N"-style holders) — it should read as "some
// AI company", not as any particular one (notably not Gemini's four-point
// sparkle or OpenAI's knot).
const GenericAILogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M12 2.4 L20.31 7.2 L20.31 16.8 L12 21.6 L3.69 16.8 L3.69 7.2 Z M6.89 9.05 L6.89 14.95 L12 17.9 L17.11 14.95 L17.11 9.05 L12 6.1 Z M15.1 12 A3.1 3.1 0 1 0 8.9 12 A3.1 3.1 0 1 0 15.1 12 Z"
      />
    </svg>
  );
};

export default GenericAILogo;
